export const productCatalogueFeatureName = 'productCatalogue';
